import React from 'react';
import {Heading, Pressable, Box, HStack, VStack} from 'native-base';
import {message} from './../../utils/messages';
import {StyleSheet} from 'react-native';
import {ColorType} from 'native-base/lib/typescript/components/types';

interface Props {
  length?: number;
  onPress?: () => void;
  label?: string;
  title?: React.ReactNode;
  summary?: string;
  icon?: JSX.Element;
  children?: React.ReactNode;
  highlight?: boolean;
  shadow?: boolean;
  borderColor?: ColorType;
  paddingY?: number;
  paddingTop?: number;
  paddingBottom?: number;
}

const DashboardItem = (props: Props) => {
  const {
    length,
    onPress: handlePressable,
    label,
    icon,
    children,
    summary,
    title,
    highlight,
    shadow,
    borderColor,
    paddingY,
    paddingTop,
    paddingBottom,
  } = props;

  const Icon = () => <>{icon}</>;

  const Title = () => <>{title}</>;

  const handleOnPress = () => {
    if (handlePressable) {
      handlePressable();
    }
  };

  const getBorderColor = (): ColorType => {
    if (borderColor) {
      return borderColor;
    }
    return highlight ? '#FF8C00' : '#0088FF';
  };

  const getPaddingY = () => {
    if (paddingY) {
      return paddingY;
    }
    return highlight ? 3 : 0;
  };

  return (
    <Pressable
      onPress={() => handleOnPress()}
      marginTop={highlight ? 4 : null}
      paddingTop={highlight ? 1 : null}>
      <Box
        borderWidth={2}
        borderRadius={15}
        borderColor={getBorderColor()}
        width={length}
        height={length}
        paddingY={getPaddingY()}
        paddingTop={paddingTop ?? null}
        paddingBottom={paddingBottom ?? null}
        paddingX={3}
        backgroundColor="#FFFFFF"
        style={shadow ? styles.shadow : null}>
        <HStack>
          <Icon />
          <VStack paddingLeft={2}>
            <HStack>
              {label && (
                <Heading
                  color={'#06355E'}
                  size="sm"
                  fontWeight="extrabold"
                  textAlign="left"
                  marginTop={summary ? 3 : 5}>
                  {message(label ?? '').toUpperCase()}{' '}
                </Heading>
              )}
              {title && <Title />}
            </HStack>
            <Heading
              color={'gray.500'}
              size="xs"
              fontWeight="semibold"
              textAlign="left">
              {message(summary ?? '')}{' '}
            </Heading>
          </VStack>
        </HStack>
        <Box>{children}</Box>
      </Box>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  shadow: {
    shadowColor: '#171717',
    shadowOffset: {width: 0, height: 6},
    shadowOpacity: 0.15,
    shadowRadius: 4,
  },
});

export default DashboardItem;
